import React from "react";
import {
  FaPlane,
  FaMountain,
  FaFilm,
  FaMusic,
  FaMasksTheater,
  FaPhotoFilm,
  FaLandmark
} from "react-icons/fa6";

function Interest() {
  const interests = [
    {
      category: "Travel & Adventure",
      items: [
        { icon: <FaPlane />, label: "Travelling" },
        { icon: <FaMountain />, label: "Hiking" }
      ]
    },
    {
      category: "Arts & Entertainment",
      items: [
        { icon: <FaFilm />, label: "Movie" },
        { icon: <FaMusic />, label: "Music" },
        { icon: <FaMasksTheater />, label: "Musical" }
      ]
    },
    {
      category: "Culture & Arts",
      items: [
        { icon: <FaPhotoFilm />, label: "Galleries" },
        { icon: <FaLandmark />, label: "Museums" }
      ]
    }
  ];

  return (
    <div className="interest-section">
      {interests.map((category, index) => (
        <div key={index} className="interest-category">
          <div className="interest-items">
            {category.items.map((item, idx) => (
              <div key={idx} className="interest-item">
                <span className="interest-icon">{item.icon}</span>
                <span className="interest-label">{item.label}</span>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default Interest;